export default __webpack_public_path__ + "static/media/separator-5.d474e9e5.svg";